import { getAppConfigValue } from '@elliemae/pui-app-sdk';

export const isScenarioDashboardEnabled = (): boolean =>
  getAppConfigValue<boolean>('partner-ui.scenarioDashboard') === true;
